import React from 'react';
import SidebarNavigation from './SidebarNavigation';
import constants from 'ndbk-constants';

import PreviewNodebook from './PreviewNodebook'
import PreviewUser from './PreviewUser'
import PreviewGroup from './PreviewGroup'
import PreviewOrganization from './PreviewOrganization'

class SearchPage extends React.Component {
    constructor(props) {
        super(props)
        this.state= {
            results : [],
            resultsNodes : {},
            error: ""
        }
    }

    search = () => {
        let text = this.props.match.params.query
        let type = this.props.match.params.type
        if (text.length > 0 && type) {
            fetch(`https://${constants.SERVER_IP}/api/search/${type}/${text}`, {
                            method: 'GET',
                            credentials: 'include',
                        })
                            .then((response)=>response.json())
                            .then((response)=>{
                                if (response.success) {
                                    this.setState({results:response.data})
								} else {
                                    this.setState({results:[]})
                                }
                            })
                            .catch((err)=>
                            {
                            })
            if (type === 'nodebooks') {
                fetch(`https://${constants.SERVER_IP}/api/search/nodes/${text}`, {
                    method: 'GET',
                    credentials: 'include',
                })
                    .then((response)=>response.json())
                    .then((response)=>{
                        if (response.success) {
                            let nodebooksDict = {}
                            response.data.forEach(node=>{
                                if(nodebooksDict[node.nodebook_id]===undefined) {
                                    let { id, ...info} = node
                                    nodebooksDict[node.nodebook_id] = {info:info, ids:[id]}
                                } else {
                                    nodebooksDict[node.nodebook_id].ids = [node.id, ...nodebooksDict[node.nodebook_id].ids]
                                }
                            })
                            this.setState({resultsNodes:nodebooksDict})
                        } else {
                            this.setState({resultsNodes:[]})
                        }
                    })
                    .catch((err)=>
                    {
                    })
            }
        } else {
            this.setState({results:[], error: "Too short search query"})
        }
    }

    componentWillMount() {
        this.search()
    }
    componentWillReceiveProps(nextProps) {
        this.props = nextProps
        this.search()
    }



    render() {
        let Component = undefined
        switch (this.props.match.params.type) {
            case "nodebooks" : Component = PreviewNodebook; break;
            case "users" : Component = PreviewUser; break;
            case "groups" : Component = PreviewGroup; break;
            case "organizations" : Component = PreviewOrganization; break;
            default : Component = undefined
        }
        let typeLabel = {
            nodebooks: "Nodebooks",
            users: "Users",
            groups: "Groups",
            organizations: "Organizations"
        }
        let results = this.state.results
        if (this.props.match.params.type === "nodebooks") {
            var myNodebooks = []
            let otherNodebooks = []
            results.forEach((value, index)=> {
                if (value.author_id === this.props.auth.user.id) {
                    myNodebooks.push(value)
                } else {
                    otherNodebooks.push(value)
                }
            })
            results = otherNodebooks;
        }

        return (
            <div className="main">
                <SidebarNavigation {...this.props}/>
                <div className="main-content">
                    <div className="container-fluid">
                    {
                        // Display user's nodebooks first if there are any
                            (this.props.match.params.type === "nodebooks" && myNodebooks.length > 0)
                                ?
                                <div>
                                    <div className="row">
                                        <div className="col-lg-12">
                                            <h2>My nodebooks</h2>
                                        </div>
                                    </div>
                                    <div className="row" >
                                    {
                                        myNodebooks.map(value =>
                                        <Component key={value.id} info={value} />
                                    )}
                                    </div>
                                </div>
                                :null
                        // --------------------------------------------------
                    }
                        <div className="row">
                            <div className="col-lg-12">
                                <h2>Results for {typeLabel[this.props.match.params.type]}</h2>
                            </div>
                        </div>
                        <div className="row" >
                            {
                                (Component)?
                                results.map(value =>
                                    <Component key={value.id} info={value} nodescription />
                                )
                                :null
                            }
                        </div>
                        {
                            (this.props.match.params.type === 'nodebooks' && this.state.resultsNodes !== {})
                            ?

                            <div><div className="row">
                                <div className="col-lg-12">
                                    <h2>Results for Nodes</h2>
                                </div>
                            </div>
                            <div className="row" >
                                {
                                    (Component)?
                                    Object.keys(this.state.resultsNodes).map((value, index) =>
                                        <Component
                                            key={'nodes'+value}
                                            info={{
                                                ...this.state.resultsNodes[value].info,
                                                id:value,
                                                title : (this.state.resultsNodes[value].ids.length > 1) ? '('+this.state.resultsNodes[value].ids.length+') ' +this.state.resultsNodes[value].info.title : this.state.resultsNodes[value].info.title
                                            }}
                                            query={'/t/ids='+this.state.resultsNodes[value].ids.join(',')}
                                            nodescription />
                                    )
                                    :null
                                }
                            </div></div>
                            :null
                        }
                    </div>

                </div>
            </div>
        )
    }
}

export default SearchPage


// WEBPACK FOOTER //
// ./src/components/SearchPage.js